<template>
<div class="opening-layer" :class="openingLayerClass">
  <div class="bg1-2">
    <template v-if="!isMobile().any">
      <div class="bg1" :style="{backgroundImage: 'url('+ bgImage(1, true) +')'}">
      </div>
      <div class="bg2" :style="{backgroundImage: 'url('+ bgImage(1, false) +')'}">
      </div>
    </template>
    <div v-else class="bgxs d-flex align-items-center">
      <img class="img-fluid" src="@/assets/images/top/bg@xs.jpg">
    </div>
  </div>
  <b-modal v-model="modalShow" id="openingLayerModal" hide-backdrop>Hello From Modal!</b-modal>
</div> 
</template>

<script>
import isMobile from 'ismobilejs'
import bg1l from '@/assets/images/top/bg-l@2x.jpg'
import bg1r from '@/assets/images/top/bg-r@2x.jpg'
import bgXs from '@/assets/images/top/bg@xs.jpg'

export default {
  name: 'OpeningLayer',
  data() {
    return {
      isMobile,
      bg1l: bg1l,
      bg1r: bg1r,
      bgXs: bgXs,
      loadedCounter: 0,
      modalShow: true
    }
  },
  mounted() {
    this.loading()
  },
  computed: {
    openingLayerClass() {
      if (this.loadedCounter >= 2) {
        return 'moving'
      } else {
        return ''
      }
    }
  },
  methods: {
    bgImage(index, isLeft) {
      if (isLeft) {
        return bg1l
      } else {
        return bg1r
      }
    },
    loading() {
      var image1 = document.createElement('img');
      image1.src = this.bg1l
      image1.onload = () => {
        this.loadedCounter++
        this.hideModal()
      };
      var image2 = document.createElement('img');
      image2.src = this.bg1l
      image2.onload = () => {
        this.loadedCounter++
        this.hideModal()
      };
    },
    hideModal() {
      if (this.loadedCounter >= 2) {
        setTimeout(() => {
          this.modalShow = false        
        }, 3500);
      }

    }
  }
}
</script>
<style lang="scss">
#openingLayerModal {
  .modal-dialog {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
.opening-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1042;
  opacity: 1;
  transition: opacity 1s;
  transition-delay: 4s;
  &:after {
    content: '';
    background-color: #888;
    position: absolute;
    top: 0;
    left: 0;
    width: 200vw;
    height: 100%;
    opacity: 1;
    transition: opacity 2.5s;
    transition-delay: 0.5s;
    transition-timing-function: linear;
  }
  .bgxs {
    position: absolute;
    background-color: #fff;
    top: 0;
    left: -40vw;
    width: 200vw;
    height: 100%;
    transition: left 3s;
    transition-timing-function: ease-out;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  .bg1-2 {
    position: absolute;
    top: 0;
    left: -40vw;
    width: 200vw;
    height: 100%;
    transition: left 3s;
    transition-timing-function: ease-out;
    .bg1 {
      position: absolute;
      top: 0;
      width: 100vw;
      height: 100%;
      background-size: cover;
      background-position: right;
      left: 0;
    }
    .bg2 {
      position: absolute;
      top: 0;
      width: 100vw;
      height: 100%;
      background-size: cover;
      background-position: left;
      left: 100vw;
    }
  }
  &.moving {
    opacity: 0;
    pointer-events: none;
    .bg1-2 {
      left: -20px;
    }
    &:after {
      opacity: 0;
    }
    .bgxs {
      left: 20px;
    }
  }
}
</style>